module.exports = __webpack_public_path__ + "img/website_bottom_image.303272b2.png";